import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivateChild } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CurrentUniversityService } from '../services/current-university.service';
import { AddonService } from '../services/addon.service';
import { map, catchError, switchMap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class AddonGuard implements CanActivate, CanActivateChild {
	constructor(
		private _router: Router,
		private _currentUniversityService: CurrentUniversityService,
		private _addonService: AddonService
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.checkAddon(route);
	}

	canActivateChild(
		childRoute: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.checkAddon(childRoute);
	}

	private checkAddon(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
		const requiredAddon = route.data['requiredAddon'];
		if (!requiredAddon) {
			return of(true);
		}

		const universityId = this._currentUniversityService.getUniversityFromStorage();
		if (!universityId) {
			// Se non c'è ateneo, permetti (o potresti bloccare, dipende dalla logica)
			// Ma le view del modulo di solito hanno bisogno di un ateneo.
			return of(this._router.parseUrl('/home'));
		}

		return this._addonService.getUniversityAddons(universityId).pipe(
			map(res => {
				const hasAddon = res.data.some(ua => ua.addon?.name?.toLowerCase() === requiredAddon.toLowerCase());
				if (hasAddon) {
					return true;
				}
				// Se non lo ha, blocco e rimando in home
				return this._router.parseUrl('/home');
			}),
			catchError(() => {
				return of(this._router.parseUrl('/home'));
			})
		);
	}
}
